import * as React from "react";

import PropTypes from "prop-types";
import { Modal, Button, Dropdown } from "semantic-ui-react";
import InputComponent from "../../InputComponent";
import BlueButton from "../../BlueButton";
import styles from "./ChooseServiceModal.module.css";
import { isEmpty } from "lodash";

const { useState } = React;

function ChooseServiceModal({
  visibility,
  onOpenModal,
  onCloseModal,
  currentCenters = [],
  setCurrentCenters,
  centers,
}) {
  const [checkedCenters, setCheckedCenters] = useState(currentCenters);

  const [searchKey, setSearchKey] = useState("");

  const onFilterCenters = (center) => {
    if (!checkedCenters.includes(center.value)) {
      setCheckedCenters([...checkedCenters, center.value]);
    } else {
      if (!isEmpty(checkedCenters)) {
        setCheckedCenters([
          ...checkedCenters.filter((c) => c !== center.value),
        ]);
      }
    }
  };

  return (
    <Modal
      size="small"
      centered
      open={visibility}
      onOpen={onOpenModal}
      onClose={onCloseModal}
    >
      <div className={`${styles.modalContainer} flex flex-col`}>
        <Button
          className={styles.closeButton}
          onClick={onCloseModal}
          size="big"
          icon="close"
        />

        <text className={`${styles.headerText} block mb-7`}>
          Choose service/s which will receive this message
        </text>

        <div className={`${styles.modalContent}`}>
          <div className={styles.inputGroup}>
            <input
              className={styles.inputBox}
              placeholder={`Search...`}
              value={searchKey}
              onChange={(e) => setSearchKey(e.target.value)}
            />
          </div>
          <div className={`${styles.servicesList}`}>
            <ul>
              {!isEmpty(centers) &&
                centers
                  .filter((center) => {
                    if (searchKey.trim()) {
                      return center.text
                        .toLowerCase()
                        .includes(searchKey.toLowerCase());
                    } else {
                      return true;
                    }
                  })
                  .map((center) => {
                    return (
                      <li
                        onClick={() => {
                          onFilterCenters(center);
                        }}
                        className={`${
                          checkedCenters.includes(center.value)
                            ? styles.selected
                            : ""
                        }`}
                      >
                        {center.text}
                        <label className={`${styles.checkbox}`}>
                          <span className={`${styles.checkmark}`}></span>
                        </label>
                      </li>
                    );
                  })}
            </ul>
          </div>

          <div className={`${styles.actionBtn}`}>
            <button
              onClick={() => {
                setCurrentCenters(checkedCenters);
                onCloseModal();
              }}
            >
              Select services
            </button>
          </div>

          <div className={styles.clearSection}>
            <button
              onClick={() => {
                setCheckedCenters([]);
                setCurrentCenters([]);
                // onCloseModal();
              }}
              className={styles.clearSectionButton}
            >
              Clear selection
            </button>
          </div>
        </div>
      </div>
    </Modal>
  );
}

ChooseServiceModal.propTypes = {
  visibility: PropTypes.bool.isRequired,
  onOpenModal: PropTypes.func.isRequired,
  onCloseModal: PropTypes.func.isRequired,
};

export default ChooseServiceModal;
